import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import numeral from 'numeral';

export default class VideoSeekBar extends Component {
  static propTypes = {
    duration: PropTypes.number.isRequired,
    buffered: PropTypes.number.isRequired,
    played: PropTypes.number.isRequired,
    paused: PropTypes.bool.isRequired,
    onCurrentTimeChange: PropTypes.func.isRequired,
  };

  state = {
    seek: 0,
    wasPlayingOnSeek: false,
  };

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onSeek);
    document.removeEventListener('mouseup', this.onEndSeek);
  }

  // Will keep the 'seek' value between 0 and 1.
  getSeekFromEvent = e => {
    const position = (e.pageX - this.seekBar.getBoundingClientRect().left) / this.seekBar.offsetWidth;
    if (position < 0 || position > 1) {
      return position > 1 ? 1 : 0;
    } else {
      return position;
    }
  };

  onStartSeek = e => {
    const seek = this.getSeekFromEvent(e);
    this.props.onCurrentTimeChange(this.props.duration * seek, false);
    this.setState({ wasPlayingOnSeek: !this.props.paused });

    document.addEventListener('mousemove', this.onSeek);
    document.addEventListener('mouseup', this.onEndSeek);
  };

  onSeek = e => {
    const seek = this.getSeekFromEvent(e);
    this.setState({ seek });

    this.props.onCurrentTimeChange(this.props.duration * seek, false);
  };

  onEndSeek = e => {
    document.removeEventListener('mousemove', this.onSeek);
    document.removeEventListener('mouseup', this.onEndSeek);

    this.props.onCurrentTimeChange(this.props.duration * this.state.seek, this.state.wasPlayingOnSeek);
    this.setState({ seek: 0, wasPlayingOnSeek: false });
  };

  onHover = e => {
    const seek = this.getSeekFromEvent(e);
    this.setState({ seek });
  };

  onEndHover = e => {
    this.setState({ seek: 0 });
  };

  setRef = seekBar => (this.seekBar = findDOMNode(seekBar));

  render() {
    const { duration, buffered, played } = this.props;

    const percentagePlayed = Math.round(100 * played / duration);
    const percentageBuffered = Math.round(100 * buffered / duration);

    return (
      <div
        className="video-player__seek-bar"
        ref={this.setRef}
        onMouseDown={this.onStartSeek}
        onMouseMove={this.onHover}
        onMouseLeave={this.onEndHover}
      >
        <div
          className="video-player__seek-bar__scrub-time"
          style={{
            display: this.state.seek ? 'block' : 'none',
            left: `${Math.round(this.state.seek * 100)}%`,
          }}
        >
          {numeral(Math.floor(this.state.seek * duration)).format('00:00:00')}
        </div>
        <div
          className="video-player__seek-bar__buffer"
          style={{
            width: `${percentageBuffered}%`,
          }}
        />
        <div
          className="video-player__seek-bar__percentage-played"
          style={{
            width: `${percentagePlayed}%`,
          }}
        />
        <div
          className="video-player__seek-bar__seeker"
          style={{
            zIndex: '2',
            height: '100%',
            width: `${Math.round(this.state.seek * 100)}%`,
            position: 'absolute',
            top: '0',
            left: '0',
            background: 'rgba(0,0,0,0.3)',
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/video/VideoSeekBar.js